/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Ground_Item_ProjectsInputs */



/**
* | output |
* | --- |
* | "Projects and tasks" |
*
* @param {Auth_Ground_Item_ProjectsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_ground_item_projects = /** @type {((inputs?: Auth_Ground_Item_ProjectsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Ground_Item_ProjectsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Projects and tasks")
});